module.exports = __webpack_public_path__ + "static/media/event-services-img31.8bf71901.jpg";